"use client";

import React from "react";

import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { TRANSITION_DURATION_200 } from "~/constants/common";
import {
  COLOR_ADDITIONAL_WARM_GRAY_3U,
  COLOR_GREYSCALE_BLACK_8,
} from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { PRODUCTS_LAYOUT_CLASSES } from "./constants";

interface StylesProps {
  isFiltersOpen: boolean;
  isChips: boolean;
}

export const MobileShopFilterContainer = styled(Box)(({ theme }) => {
  const { BREAKPOINT_TABLET, BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    [`& .${PRODUCTS_LAYOUT_CLASSES.mobileShopFilter}`]: {
      padding: theme.spacing(0.75, 2),
      margin: theme.spacing(0, -2),
      background: COLOR_ADDITIONAL_WARM_GRAY_3U,
      [BREAKPOINT_TABLET]: {
        padding: theme.spacing(0.75, 4),
        margin: theme.spacing(0, -4),
      },
      [BREAKPOINT_DESKTOP]: {
        display: "none",
      },
    },
  };
});

export const ProductsLayoutContainer = styled(
  ({ isFiltersOpen, isChips, ...restProps }: StylesProps & BoxProps) => (
    <Box {...restProps} />
  ),
)(({ theme, isFiltersOpen, isChips }) => {
  const { BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    display: "flex",
    gap: theme.spacing(3),
    margin: theme.spacing(0, 0, 3),
    overflow: isFiltersOpen ? "hidden" : "unset",
    height: isFiltersOpen ? 0 : "unset",
    [BREAKPOINT_DESKTOP]: {
      margin: theme.spacing(3, 0),
    },
    [`& .${PRODUCTS_LAYOUT_CLASSES.productsLayoutContainer}`]: {
      overflowX: "hidden",
    },
    [`& .${PRODUCTS_LAYOUT_CLASSES.productListWrapper}`]: {
      flexGrow: 1,
    },
    [`& .${PRODUCTS_LAYOUT_CLASSES.topBar}`]: {
      height: 56,
      alignItems: "center",
      display: "flex",
      borderBottom: isChips ? `1px solid ${COLOR_GREYSCALE_BLACK_8}` : "unset",
    },
    [`& .${PRODUCTS_LAYOUT_CLASSES.filterChipsContainer}`]: {
      transition: TRANSITION_DURATION_200,
      padding: isChips ? theme.spacing(3, 0) : "0",
    },
    [`& .${PRODUCTS_LAYOUT_CLASSES.filterChip}`]: {
      margin: theme.spacing(0.5, 1, 0.5, 0),
      "&:last-of-type": {
        marginRight: theme.spacing(2.5),
      },
      "& .MuiChip-deleteIcon:hover": {
        backgroundColor: "transparent",
      },
    },
  };
});
